module.exports = __webpack_public_path__ + "img/sticker_9.b5ca9439.svg";